import React from 'react';
import _ep_BANNER_BANNER_FULL from "../components/_ep_BANNER_BANNER_FULL";

const _epBanner = (props) => {
    const banner = props?.banner !== undefined ? props.banner : props;
    const isFirstHomeSection = props?.isFirstHomeSection === true;

    switch (banner?.ViewType) {
        case "BANNER_FULL":
            return (
                <_ep_BANNER_BANNER_FULL
                    banners={banner?.Items}
                    eagerFirstBanner={isFirstHomeSection}
                />
            );
        default:
            return null;
    }
};

export default React.memo(_epBanner);
